import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=a3190c72&scoped=true&"
import script from "./Workspaces.vue?vue&type=script&lang=js&"
export * from "./Workspaces.vue?vue&type=script&lang=js&"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=a3190c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3190c72",
  null
  
)

export default component.exports